import React from "react";
import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const auth = useAuth();

    if (auth.isLoading) {
        return <div>Carregando autenticação...</div>;
    }

    if (!auth.isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}

export { ProtectedRoute };